import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/site";

export default function WhatsAppFab() {
  const wa = COMPANY.whatsapp.replace(/[^0-9]/g, "");
  return (
    <a
      href={`https://wa.me/${wa}?text=${encodeURIComponent("Hi L F Building, I'd like to enquire about a project.")}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 left-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_10px_30px_rgba(37,211,102,0.5)] hover:bg-[#1ebe5d] hover:scale-105 transition-all"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
}
